module.exports = __webpack_public_path__ + "static/media/dineIn.72d10c30.pdf";